import {
  Card,
  CardContent,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import type { LucideIcon } from "lucide-react";

type MetricWidgetSkeletonProps = {
  title: string;
  icon: LucideIcon;
};

export function MetricWidgetSkeleton({
  title,
  icon: Icon,
}: MetricWidgetSkeletonProps) {
  return (
    <Card className="bg-card py-4">
      <CardContent className="px-4">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-base dark:text-zinc-300">{title}</h3>
          <Icon className="size-4 dark:text-zinc-300" />
        </div>
        <div className="mt-1">
          <Skeleton className="h-8 w-16" />
        </div>
      </CardContent>
    </Card>
  );
}
